import React from "react";

const WorekrFooter = () => {
   return (
      <>
         {/* ================= DESKTOP FOOTER (UNCHANGED) ================= */}
         <div className="d-none d-md-block">
            <footer className="pt-4 pt-lg-5 pb-3 font-size-16">
               <div className="container">

                  {/* TOP ROW */}
                  <div className="row align-items-center">

                     {/* Text */}
                     <div className="col-md-7 col-lg-6 col-xl-6 mb-4 line-hight-4">
                        <p className="mb-2 font-size-16 font-weight-bold line-hight-3 footer-text">
                           Strengthening the Childcare Workforce
                        </p>
                        <p className="mb-0 font-size-20 font-weight-normal line-hight-3">
                           Reinvesting in the future of childcare through collaboration, resources, and national partnerships.
                        </p>
                     </div>

                     {/* Contact */}
                     <div className="col-md-5 col-lg-6 col-xl-6 mb-md-4">
                        <div className="col-lg-8 mb-4">
                           <div className="row gx-4">

                              <div className="col-auto">
                                 <h3 className="font-weight-semibold">Let's Connect:</h3>
                                 <a href={process.env.REACT_APP_CONTACT_US} className="footer-text text-decoration-underline">
                                    Contact Us
                                 </a>
                              </div>

                              <div className="col-auto">
                                 <h3 className="font-weight-semibold">Email:</h3>
                                 <p className="footer-text">info@ncafoundation.org</p>
                              </div>

                           </div>
                        </div>
                     </div>

                  </div>

                  {/* MIDDLE ROW */}
                  <div className="row align-items-start">

                     {/* LEFT */}
                     <div className="col-lg-6 mb-4">
                        <div className="footer-text mt-2" style={{ fontSize: "14px" }}>
                           <p className="mb-2 font-size-16 font-weight-bold line-hight-3 footer-text">
                              National Childcare Alliance Foundation (NCAF)
                           </p>
                           <p className="mb-2 font-size-18 font-weight-normal line-hight-3">
                              A registered 501(c)(3) nonprofit organization
                           </p>
                           <p className="mb-0 font-size-18 font-weight-normal line-hight-3">
                              EIN: 39-2178199
                           </p>
                           <p className="mb-2 font-size-18 font-weight-normal line-hight-3">
                              Address: P.O. Box 4656, Norfolk, VA 23523
                           </p>
                           <p className="mb-0 font-size-18 font-weight-normal line-hight-3">
                              Official Website:{" "}
                              <a href="https://ncafoundation.org" target="_blank" rel="noreferrer">
                                 https://ncafoundation.org
                              </a>
                           </p>
                        </div>
                     </div>

                     {/* RIGHT */}
                     <div className="col-lg-6 mb-4">
                        <h3 className="font-weight-semibold mb-3">Social media:</h3>

                        <div className="footer-social d-flex align-items-center gap-3">
                           <a href={process.env.REACT_APP_FACEBOOK_URL} className="footer-icon">
                              <i className="fa fa-facebook"></i>
                           </a>

                           <a href={process.env.REACT_APP_INSTAGRAM_URL} className="footer-icon">
                              <i className="fa fa-instagram"></i>
                           </a>

                           <a href={process.env.REACT_APP_LINKEDIN_URL} className="footer-icon">
                              <i className="fa fa-linkedin"></i>
                           </a>

                           <a href={process.env.REACT_APP_YOUTUBE_URL} className="footer-icon">
                              <i className="fa fa-youtube-play"></i>
                           </a>
                        </div>
                     </div>

                  </div>

                  {/* BOTTOM ROW */}
                  <div className="row align-items-center py-4 footer-top">

                     <div className="col-lg-4 col-md-12 mb-3 mb-lg-0 text-center text-lg-start">
                        <img
                           src="/assets/images/NCAF_Logo.png"
                           alt="logo"
                           className="footer-logo mb-2"
                           style={{ width: "200px", height: "100px" }}
                        />

                        <p className="mb-0 footer-copy">
                           Copyright © 2026 4ncaf, All Rights Reserved
                        </p>
                     </div>

                     <div className="col-lg-8 col-md-12">
                        <nav className="footer-nav">
                           <ul className="d-flex flex-wrap justify-content-center justify-content-lg-end gap-3 mb-0">
                              <li><a href={process.env.REACT_APP_ABOUT_US}>About</a></li>
                              <li><a href={process.env.REACT_APP_SUPPORT}>Support</a></li>
                              <li><a href={process.env.REACT_APP_PRIVACY_POLICY}>Privacy</a></li>
                              <li><a href={process.env.REACT_APP_TERMS_CONDITION}>Terms</a></li>
                           </ul>
                        </nav>
                     </div>

                  </div>

               </div>
            </footer>
         </div>

         {/* ================= MOBILE FOOTER (NEW CLEAN VERSION) ================= */}
         <div className="d-block d-md-none">
            <footer className="pt-4 pb-3 font-size-16">
               <div className="container">

                  {/* 1. TOP TEXT */}
                  <div className="mb-4">
                     <p className="mb-2 font-weight-bold">
                        Strengthening the Childcare Workforce
                     </p>
                     <p className="mb-0">
                        Reinvesting in the future of childcare through collaboration, resources, and national partnerships.
                     </p>
                  </div>

                  {/* 2. FOUNDATION INFO */}
                  <div className="mb-4">
                     <p className="mb-2 font-weight-bold">
                        National Childcare Alliance Foundation (NCAF)
                     </p>
                     <p className="mb-1">A registered 501(c)(3) nonprofit organization</p>
                     <p className="mb-1">EIN: 39-2178199</p>
                     <p className="mb-1">Address: P.O. Box 4656, Norfolk, VA 23523</p>
                     <a href="https://ncafoundation.org" target="_blank" rel="noreferrer">
                        Official Website
                     </a>
                  </div>

                  {/* 3. CONTACT */}
                  <div className="mb-4">
                     <h5 className="font-weight-semibold">Let’s Connect</h5>
                     <a href={process.env.REACT_APP_CONTACT_US} className="footer-text text-decoration-underline">Contact Us</a>
                     <h2 className="font-weight-semibold mt-1">Email:</h2>
                     <p className="mb-0">info@ncafoundation.org</p>
                  </div>

                  {/* 4. SOCIAL */}
                  <div className="mb-4">
                     <h5 className="font-weight-semibold">Social Media</h5>

                     <div className="footer-social d-flex gap-3">
                        <a href={process.env.REACT_APP_FACEBOOK_URL} className="footer-icon">
                           <i className="fa fa-facebook"></i>
                        </a>

                        <a href={process.env.REACT_APP_INSTAGRAM_URL} className="footer-icon">
                           <i className="fa fa-instagram"></i>
                        </a>

                        <a href={process.env.REACT_APP_LINKEDIN_URL} className="footer-icon">
                           <i className="fa fa-linkedin"></i>
                        </a>

                        <a href={process.env.REACT_APP_YOUTUBE_URL} className="footer-icon">
                           <i className="fa fa-youtube-play"></i>
                        </a>
                     </div>
                  </div>

                  <hr className="d-block d-md-none my-4" />

                  {/* 5. LOGO + COPYRIGHT */}
                  <div className="text-center mt-4">
                     <div className="col-lg-8 col-md-12">
                        <nav className="footer-nav mb-4">
                           <ul className="d-flex flex-wrap justify-content-center justify-content-lg-end gap-3 mb-0">
                              <li><a href={process.env.REACT_APP_ABOUT_US}>About</a></li>
                              <li><a href={process.env.REACT_APP_SUPPORT}>Support</a></li>
                              <li><a href={process.env.REACT_APP_PRIVACY_POLICY}>Privacy</a></li>
                              <li><a href={process.env.REACT_APP_TERMS_CONDITION}>Terms</a></li>
                           </ul>
                        </nav>
                     </div>
                     <img
                        src="/assets/images/NCAF_Logo.png"
                        alt="logo"
                        style={{ width: "140px", height: "auto" }}
                     />
                     <p className="mb-0 mt-2">
                        Copyright © 2026 4ncaf
                     </p>
                  </div>

               </div>
            </footer>
         </div>
      </>
   );
};

export default WorekrFooter;